export function engagementAreasFromSuggestion(suggestion) {
    const recommended = (suggestion?.recommended_scope_areas || [])
        .map(item => item?.name || item)
        .filter(Boolean);
    const additional = (suggestion?.additional_scope_areas || suggestion?.also_consider_scope_areas || [])
        .map(item => item?.name || item)
        .filter(Boolean)
        .filter(name => !recommended.some(item => item.toLowerCase() === String(name).toLowerCase()));
    return { recommended, additional };
}

export function buildItemsFromSuggestion(suggestion, existing = []) {
    const existingByName = new Map((existing || []).map(ws => [ws.name, ws]));
    const recommended = (suggestion?.recommended_workstreams || []).map(row => ({
        key: row.workstream_id || row.name,
        name: row.name,
        description: row.description || '',
        reason: row.reason || '',
        recommended: true,
        selected: true,
        existingId: existingByName.get(row.name)?.id,
        originalName: existingByName.get(row.name)?.name || row.name,
    }));
    const additional = (suggestion?.additional_relevant_workstreams || []).map(row => ({
        key: row.workstream_id || row.name,
        name: row.name,
        description: row.description || '',
        reason: row.reason || '',
        recommended: false,
        selected: false,
        existingId: existingByName.get(row.name)?.id,
        originalName: existingByName.get(row.name)?.name || row.name,
    }));
    const items = [...recommended];
    additional.forEach(item => {
        if (items.some(existingItem => existingItem.name.toLowerCase() === item.name.toLowerCase())) return;
        items.push(item);
    });
    (existing || []).forEach(ws => {
        if (!ws?.name || items.some(item => item.name === ws.name || item.existingId === ws.id)) return;
        items.push({
            key: `existing-${ws.id}`,
            name: ws.name,
            description: ws.description || '',
            reason: '',
            recommended: false,
            selected: false,
            existingId: ws.id,
            originalName: ws.name,
        });
    });
    return items;
}

export function sourceRank(source) {
    const value = String(source || '').toLowerCase();
    if (value.includes('document')) return 3;
    if (value.includes('coresignal')) return 2;
    if (value.includes('custom')) return 1;
    return 0;
}

export function applyOrganisationSuggestion(current, patch, fieldMeta = {}, previous = {}) {
    const next = { ...current, fieldMeta: { ...(current.fieldMeta || {}) } };
    Object.entries(patch || {}).forEach(([key, value]) => {
        if (value == null || value === '') return;
        const incomingSource = fieldMeta[key]?.source;
        const currentSource = current.fieldMeta?.[key]?.source;
        const incomingRank = sourceRank(incomingSource);
        const currentRank = sourceRank(currentSource);
        const currentValue = current[key];
        const previousValue = previous[key];
        const empty = currentValue == null || currentValue === '';
        const userEdited = !empty && currentValue !== previousValue && currentRank === 0;
        if (userEdited) return;
        if (incomingRank > currentRank || empty || currentValue === previousValue) {
            next[key] = value;
            if (fieldMeta[key]) next.fieldMeta[key] = fieldMeta[key];
        }
    });
    return next;
}
